export const CLEAN_FORM = 'fuerzaventas/gestionpreciosespeciales/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/gestionpreciosespeciales/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/gestionpreciosespeciales/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/gestionpreciosespeciales/receive-v-list';
export const RECEIVE_V_LIST2 = 'fuerzaventas/gestionpreciosespeciales/receive-v-list2';
export const REQUEST_V_LIST = 'fuerzaventas/gestionpreciosespeciales/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/gestionpreciosespeciales/error-v-list';
export const SET_MASK = 'fuerzaventas/gestionpreciosespeciales/set-mask';
export const SET_ORDER = 'fuerzaventas/gestionpreciosespeciales/set-order';
export const RECEIVE_DATA= 'fuerzaventas/gestionpreciosespeciales/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/gestionpreciosespeciales/update-table-column';
export const SET_PAGE = 'fuerzaventas/gestionpreciosespeciales/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/gestionpreciosespeciales/set-selected-row';